// ============================================================================
// BOOK · keys — how a card and a group are named, so a saved order survives
// ============================================================================
// David 22.10 (STOP A): the model key carries its kind.
//   new model   'N:' + the first token of dev_no (else item_no), upper case
//   repeat      'R:' + item_no, upper case — R and RNC lines of one item are one card
// dev_no stays on a line when Orders gives it a CL code, so the key never
// changes and the card keeps its place; only the code shown changes.
// The group key: 'shape/sub|Family|R' in the display spellings.
// ============================================================================

const CL_RE = /^CL\d{4,5}$/i;

export const tokenOf = (v) => String(v == null ? '' : v).trim().split(/\s+/)[0].toUpperCase();
export const isCL = (code) => CL_RE.test(String(code || '').trim());

/** The dev number of a line ('OG' is a marker in the Order Book, never a number). */
export function devOf(line) {
  const t = tokenOf(line.dev_no);
  return t && t !== 'OG' ? t : '';
}

export const rnOf = (line) => (String(line.type || '').toUpperCase() === 'N' ? 'N' : 'R');

export function modelKeyOf(line) {
  const item = tokenOf(line.item_no);
  if (rnOf(line) === 'N') return `N:${devOf(line) || item}`;
  return `R:${item}`;
}

/** The code on the card: the CL code when the line has one, otherwise the dev number. */
export function codeOf(item, dev) {
  const it = tokenOf(item);
  if (isCL(it)) return it;
  return dev || it;
}

export const groupKeyOf = (sectionKey, fam, rn) => `${sectionKey}|${fam}|${rn}`;
